import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import GovNavBar from './components/govNavBar';
import TittleNavBar from './components/tittleNavBar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Cadastre from './pages/Cadastre';
import Rules from './pages/Rules';
import CadastralDuties from './pages/CadatralDuties';
import CitizenDuties from './pages/CitizenDuties';
import Navigability from './pages/Navigability';
import Procedures from './pages/Procedures';
import ContactUs from './pages/ContactUs';
import Questions from './pages/Questions';
import Geoportal from './pages/Geoportal';
import Participa from './pages/Participa';
import Dashboard from './pages/Dashboard';
import Observatory from './pages/Observatory';
import ControlPanel from './pages/ControlPanel';
import ChangePassword from './pages/ChangePassword';
import Profile from './pages/Profile';
import NotFoundPage from './pages/NotFoundPage';
import ActivateAccount from './pages/ActivateAccount';
import CryptoJS from 'crypto-js'
import { KEY } from "./config";


import { MyNewsProvider } from "./context/NewsContext";
import { MyProceduresProvider } from "./context/ProceduresContext";
import { MyRequirementsProvider } from "./context/RequirementsContext";
import { MyQuestionsProvider } from "./context/QuestionsContext";
import { MyRulesProvider } from "./context/RulesContext";
import { MyAuthProvider } from './context/AuthContext';
import { MyProcedureClassesProvider } from './context/ProcedureClassesContext';
import { MyParticipateWaysProvider } from './context/ParticipateWaysContext';
import { MyOpenDataProvider } from './context/OpenDataContext';
import OpenData from './pages/OpenData';

function App() {

  const decryptSession = () => {
    const session = window.localStorage.getItem("session");
    if (session) {
      const bytes = CryptoJS.AES.decrypt(session, KEY);
      return bytes.toString(CryptoJS.enc.Utf8);
    }
  }

  const decryptUserRole = () => {
    const userRole = window.localStorage.getItem("userRole");
    if (userRole) {
      const bytes = CryptoJS.AES.decrypt(userRole, KEY);
      return bytes.toString(CryptoJS.enc.Utf8);
    }
  }
  return (
    <MyNewsProvider>
    <MyProceduresProvider>
    <MyRequirementsProvider>
    <MyQuestionsProvider>
    <MyRulesProvider>
    <MyAuthProvider>
    <MyProcedureClassesProvider>
    <MyParticipateWaysProvider>
    <MyOpenDataProvider>
    <Router>
      <GovNavBar />
      <Routes>
        {decryptUserRole() === "1" && <Route path="/control" element={<ControlPanel />} />}
        <Route path="/" element={<Home />} scrollToTop={true} />
        <Route exact path="/catastro" element={<Cadastre />} scrollToTop={true} />
        <Route path="/normatividad" element={<Rules />} />
        <Route path="/funciones" element={<CadastralDuties />} />
        <Route path="/navegabilidad" element={<Navigability />} />
        <Route path="/tramites" element={<Procedures />} />
        <Route path="/deberesdelciudadano" element={<CitizenDuties />} />
        <Route path="/contactenos" element={<ContactUs />} />
        <Route path="/preguntasfrecuentes" element={<Questions />} />
        <Route path="/datosabiertos" element={<OpenData />} />
        <Route path="/geoportal" element={<Geoportal />} />
        <Route path="/participa" element={<Participa />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/observatorio" element={<Observatory />} />
        <Route path="/cambiarcontrasena/:userEmail/:userToken" element={<ChangePassword />} />
        {decryptSession() === "true" && <Route path="/perfil" element={<Profile />} />}
        <Route path="/activarcuenta/:userEmail/:userToken" element={ <ActivateAccount />}/>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </Router>
    </MyOpenDataProvider>
    </MyParticipateWaysProvider>
    </MyProcedureClassesProvider>
    </MyAuthProvider>
    </MyRulesProvider>
    </MyQuestionsProvider>
    </MyRequirementsProvider>
    </MyProceduresProvider>
    </MyNewsProvider>
  );
}

export default App;
